import player_portals_form from './map-player_portals_form';
import {
  getFirstLinkedItemOrDefault,
  getSingleChoiceValue,
} from '@r-and-a-shared-ui/common-kontent-client/utils';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getCtaHrefValue } from './utils';

export const player_portals_on_site_registration_admin_panel = (
  entry: PLAYER_PORTALS_MODELS.OnSiteRegistrationAdminPanel,
) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const registrationForm = player_portals_form(
    getFirstLinkedItemOrDefault(
      entry.elements.registration_form,
    ) as PLAYER_PORTALS_MODELS.Form,
  );

  const createCaddieForm = player_portals_form(
    getFirstLinkedItemOrDefault(
      entry.elements.create_caddie_form,
    ) as PLAYER_PORTALS_MODELS.Form,
  );

  const { elements } = entry;
  return {
    title: elements.title?.value,
    pageSize: elements.participants_page_size?.value,
    registrationForm: registrationForm,
    createCaddieForm: createCaddieForm,
    dashboard: {
      registeredLabel: elements.registered_label?.value,
      notRegisteredLabel: elements.not_registered_label?.value,
      dataFilledInAndNotRegisteredLabel:
        elements.data_filled_in_and_not_registered_label?.value,
    },
    policies: {
      policySectionTitle: elements.policy_acceptance_section_title?.value,
      antiDopingPolicyText: elements.anti_doping_policy_text?.value,
      antiBettingPolicyText: elements.anti_betting_policy_text?.value,
      privacyPolicySectionText: elements.privacy_policy_section_text,
    },
    actionBtnLabels: {
      reSendSMSBtnLabel: elements.re_send_sms_button_label?.value,
      reSendEmailBtnLabel: elements.re_send_email_button_label?.value,
      agreeToPoliciesBtnLabel: elements.agree_to_policies_button_label?.value,
      completeRegistrationBtnLabel:
        elements.complete_registration_button_label?.value,
    },
    dataSource: getSingleChoiceValue(elements.data_source),
    communicationConfigs: {
      smsConfig: {
        from: elements.sms_from?.value,
        templateSid: elements.sms_template_sid?.value,
        callbackUrl: getCtaHrefValue(
          getFirstLinkedItemOrDefault(elements?.sms_callback_url),
        ),
      },
      emailConfig: {
        from: elements.email_from?.value,
        replyTo: elements.email_reply_to?.value,
        subject: elements.email_subject?.value,
        templateName: elements.email_template_name?.value,
        callbackUrl: getCtaHrefValue(
          getFirstLinkedItemOrDefault(elements?.email_callback_url),
        ),
      },
    },
  };
};

export default player_portals_on_site_registration_admin_panel;
